export const shareUserDataStatus = {
  reviewFrontlineUnseen: 'review_frontline_unseen',
  reviewFrontlineSeen: 'review_frontline_seen',
  reviewOfficeUnseen: 'review_office_unseen',
  reviewOfficeSeen: 'review_office_seen',
  resolvedOffice: 'resolved_office',
}
